import { Container } from 'rsuite';
import styled from 'styled-components';

export default styled(Container)`
  flex-direction: row !important;
`;
